<template>
  <div class="maps">
    <div id="map-display-wrapper" class="map-wrapper"  :class="{ closed: isClosed }">
      <Map @marker-clicked="selectMarker" :geojson="currentGeoJSON" :fillOpacity="fillOpacity" :zoom="zoom" :towns="mapTownData" :isFullscreen="isClosed"/>
      <div class="filter-toggle" @click="selectFilter" >
        <img id="filter-icon" :class="{ isActive: filterActive }" src="@/assets/images/filter-empty.svg" >
      </div>
      <LayerToggle @change-layer="changeDisplayedLayer"/>
    </div>
    <div id="map-info-wrapper" class="map-wrapper" :class="{ closed: isClosed }" >
      <MapInfo 
        
        @drawer-close="closeDrawer"
        @filter-change="onFilterChange" 
        :searchActive="searchActive"
        :filteredProducers="filteredProducers"
        :fermenterDropDownData="fermenterDropDownData" 
        :stillDropDownData="stillDropDownData"
        :brandDropDownData="brandDropDownData" >
      </MapInfo>
    </div>
  </div>
</template>

<script>
import Map from "@/components/Map.vue";
import LayerToggle from "@/components/LayerToggle.vue";
import MapInfo from "@/components/MapInfo.vue";
// import SearchToggle from "@/components/SearchToggle.vue";
import {mexicoStates, mexicoClimate, mexicoTerrain} from '@/assets/geoJSON/geodata.js';
import {spanishStillLabels, spanishFermenterLabels} from '@/assets/JSON/data.js'


export default {
  name: 'Maps',
  components: {
    Map,
    LayerToggle,
    MapInfo,
    // SearchToggle
  },
  data() {
      return {
      zoom: 4,
      isClosed: true,
      searchActive: false,
      brands: [],
      producers: [],
      brandsToProducers: [],
      stills: [],
      towns: [],
      fermenters: [],
      municipalities: [],
      states: [],
      currentGeoJSON: mexicoStates,
      fillOpacity: .45,
      filteredProducers: [],
      fermenterDropDownData: [],
      stillDropDownData: [],
      brandDropDownData: [],
      mapTownData: [],
      filterActive: false,
    }
  },
  async mounted () {
    this.setupData();
    const versionNumber = await this.$getItem('versionNumber');
    if (!versionNumber){
      setTimeout(this.setupData, 1151);
    } 

    window.scrollTo(0,0);

    if (this.$i18n.i18next.language === 'es'){
      this.convertLabelsToSpanish()
    }
    if(this.$store.state.currentTown.id){
      this.zoom = 8;
    }
  },
  methods: {
    async setupData(){
      this.brands = await this.$getItem('brands');
      this.brandDropDownData = await this.$getItem('brands');
      this.producers = await this.$getItem('producers');
      this.filteredProducers = await this.$getItem('producers');
      this.brandsToProducers = await this.$getItem('brandsToProducers');
      this.stills = await this.$getItem('stills');
      this.stillDropDownData = await this.$getItem('stills');
      this.towns = await this.$getItem('towns');
      this.mapTownData = await this.$getItem('towns');
      this.fermenters = await this.$getItem('fermenters');
      this.fermenterDropDownData = await this.$getItem('fermenters');
      this.municipalities = await this.$getItem('municipalities');
      this.states = await this.$getItem('states');


      if (this.fermenterDropDownData.length != 0){
        this.filteredProducers.sort(this.sortByName);
        this.fermenterDropDownData.sort(this.sortByName);
        this.stillDropDownData.sort(this.sortByName);
        this.brandDropDownData.sort(this.sortByName);
      }
    },
    sortByName(a, b) {
      if (a.name < b.name){
        return -1;
      }

      if (a.name > b.name){
        return 1;
      }
      return 0;
    },
    closeDrawer() {
      this.isClosed = true;
    },
    selectMarker() {
      this.isClosed = false;
      this.searchActive = false;
    },
    selectFilter() {
      if (this.isClosed) {
        this.isClosed = false;
        this.searchActive = true;
      } else {
        this.searchActive = !this.searchActive;
      }
    },
    changeDisplayedLayer(event) {
      if (event === 'mexicoStates') {
        this.fillOpacity = .45;
        this.currentGeoJSON = mexicoStates;
      } else if (event === 'mexicoClimate') {
        this.currentGeoJSON = mexicoClimate
        this.fillOpacity = .45;
      } else if (event === 'mexicoTerrain') {
        this.fillOpacity = 0;
        this.currentGeoJSON = mexicoTerrain;
      }
    },
    onFilterChange(filtersSelected) {
      this.filterActive = filtersSelected.filterActive;
      const relevantProducers = this.filterProducers(filtersSelected);
      this.filteredProducers = relevantProducers.sort(this.sortByName);

      const relevantFermenters = this.getProducersFermenters(this.filteredProducers);
      this.fermenterDropDownData = relevantFermenters.sort(this.sortByName);

      const relevantStills = this.getProducersStills(this.filteredProducers);
      this.stillDropDownData = relevantStills.sort(this.sortByName);

      const relevantBrands = this.getProducersBrands(this.filteredProducers);
      this.brandDropDownData = relevantBrands.sort(this.sortByName);
      this.mapTownData = this.getProducersTowns(this.filteredProducers);
    },
    filterProducers(filtersSelected){
      //filter down producers based on criteria
      return this.producers.filter(producer => {
        const isStillMatching = filtersSelected.stillType === null || producer.still_id === filtersSelected.stillType;
        const isFermenterMatching = filtersSelected.fermenterType === null || producer.fermenter_id === filtersSelected.fermenterType;

        const producerIds = this.getProducersIdsForBrands(filtersSelected);
        const isBrandMatching = filtersSelected.brandName === null || producerIds.includes(producer.id);
        return  isStillMatching && isFermenterMatching && isBrandMatching;
      });
    },
    getProducersFermenters(filteredProducers){
      const fermenterIds = filteredProducers.map(producer => producer.fermenter_id);
      
      return this.fermenters.filter(fermenter => fermenterIds.includes(fermenter.id));
    },
    getProducersStills(filteredProducers){
      const stillIds = filteredProducers.map(producer => producer.still_id);

      return this.stills.filter(still => stillIds.includes(still.id));
    },
    getProducersTowns(filteredProducers){
      const townIds = filteredProducers.map(producer => producer.town_id);

      return this.towns.filter(town => townIds.includes(town.id));
    },
    getProducersBrands(filteredProducers){
      const producerIds = filteredProducers.map(producer => producer.id);
      const joins = this.brandsToProducers.filter(join => producerIds.includes(join.producer_id));

      const brandIds = joins.map(join => join.brand_id);
      const filteredBrands = this.brands.filter(brand => brandIds.includes(brand.id));

      return filteredBrands;
    },
    getProducersIdsForBrands(filtersSelected){
      const joiningIds = this.brandsToProducers.filter(brand => filtersSelected.brandName === brand.brand_id);

      return joiningIds.map(join => join.producer_id);
    },
    convertLabelsToSpanish(){
      this.stills = spanishStillLabels;
      this.stillDropDownData = spanishStillLabels;
      this.fermenters = spanishFermenterLabels;
      this.fermenterDropDownData = spanishFermenterLabels;
    }

  }
}

</script>

<style lang="scss" scoped>

.maps {
  height: 100vh;
  padding-top: 96px;
  margin-top: -96px;
  
}

.map-wrapper {
  height: 50%;
  transition: height 250ms; 
}

.filter-toggle {
    height: 40px;
    width: 40px;
    z-index: 500;
    position: relative;
    top: -54px;
    left: 10px;
}

#filter-icon {
    height: 40px;
    width: 40px;
    background-color: #FFFFF7;
    box-sizing: border-box;
    border: 1px solid black;
    padding: 1px;
    box-shadow: 1px 1px 5px 0px rgba(0,0,0,0.25);
}

#filter-icon.isActive {
    border: 2px solid black;
    content: url("../assets/images/filter-full.svg");
    animation: pulse 2.2s ease-in infinite;
}

#map-info-wrapper.closed {
  height: 0%;
  overflow-y: hidden;
}

#map-display-wrapper.closed {
  height: 100%;

}

@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    opacity: 0.9;
 }

 50% {
    -webkit-transform: scale(1.08);
    opacity: 1;
 }

 100% {
    -webkit-transform: scale(1);
    opacity: 0.9;
 }
}


</style>